import { isMobile } from 'react-device-detect';

import { theme } from 'shared/styles/theme';
import { Flex } from 'shared/ui/StyledComponents';

import styled from '@emotion/styled';

export const TodoButton = styled(Flex)`
  background-color: ${theme.colors.black};
  width: 50px;
  height: 50px;
  position: ${isMobile ? 'absolute' : 'none'};
  right: 30px;
  bottom: 30px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s;
  border: ${isMobile ? 'none' : '2px solid white'};

  & path {
    color: ${theme.colors.black};
  }

  & rect {
    color: ${theme.colors.white};
  }

  &:hover {
    background-color: ${theme.colors.yellow300};

    & path {
      color: ${theme.colors.yellow300};
    }

    & rect {
      color: ${theme.colors.black};
    }

    & div {
      background-color: ${theme.colors.yellow800};
      color: ${theme.colors.black};
    }
  }
`;

export const TodoCounter = styled(Flex)`
  background-color: ${theme.colors.gray800};
  color: ${theme.colors.yellow800};
  font-weight: ${theme.fontWeights.bold};
  font-size: 16px;
  position: absolute;
  bottom: 5px;
  left: -10px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: ${isMobile ? 'none' : '2px solid white'};
`;
